import { getAxios} from './axiosActions';
import { GET_DASHBOARD_DATA, GET_DASHBOARD_ATTENDANCE_SUMMARY, GET_DASHBOARD_CALENDAR_DATA_ALL } from './actionTypes';

export const getDashboardData = () => {
    let params = { callTime: new Date() };
    const url = 'Dashboard/GetDashboardData';
    const request = getAxios(url, { params: params });
    return {
        type: GET_DASHBOARD_DATA,
        payload: request
    }
};

export const getCalendarDataAll = () => {
    let params = { callTime: new Date() };
    const url = 'Dashboard/GetCalendarDataAll';
    const request = getAxios(url, { params: params });
    return {
        type: GET_DASHBOARD_CALENDAR_DATA_ALL,
        payload: request
    }
};

export const getEmployeeAttendanceSummary = () => {
    let params = { callTime: new Date() };
    const url = 'Dashboard/GetEmployeeAttendanceSummary';
    const request = getAxios(url, { params: params });
    return {
        type: GET_DASHBOARD_ATTENDANCE_SUMMARY,
        payload: request
    }
};